<template>
  <div class="animated fadeIn">
    <!-- <CRow>
      <CCol sm="12" md="12">
        <div class="app flex-row align-items-center">
          <div class="container d-flex justify-content-center">
            <PulseLoader float />
          </div>
        </div>
      </CCol>
    </CRow> -->
    <CRow>
      <CCol sm="12">
        <CCard>
          <CRow>
            <CCol sm="12">
              <table class="table table-responsive-sm table-hover table-outline mb-0">
                <thead class="thead-light">
                  <tr>
                    <th></th>
                    <th>My Description</th>
                    <th>My Date</th>
                    <th>Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>1</td>

                    <td>Payment C784-F3-MATH for Nur Dalila Tasneem</td>
                    <td>2022-01-20 15:22:06</td>
                    <td>2</td>
                  </tr>
                  <tr>
                    <td>2</td>

                    <td>Payment C1256-S5-MATH(40min) for Sarvin Jaasvir</td>
                    <td>2022-01-20 09:14:42</td>
                    <td>2</td>
                  </tr>
                </tbody>
              </table>
            </CCol>
          </CRow>
          <br />
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import _ from "lodash";
import Vue from "vue";
Vue.use(require("vue-moment"));
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import axios from "axios";
import Table from './base/Table.vue';

Vue.component("downloadExcel");

export default {
  name: "Duplicate Transaction",
  components: {PulseLoader},
  data: function() {
    return {
    };
  },
  
};
</script>